import { useContext, useMemo } from 'react'
import { CommandCenterStateProviderContext } from '../context';
import { LoaderTypeFor, LoaderTypes } from '../types';

const useLoader = () => {
    const context = useContext(CommandCenterStateProviderContext);

    if (context === undefined) {
        throw new Error('useLoader must be used within a LoaderProvider');
    }
    const { commandCenterLoader, setCommandCenterLoader } = context;

    const loading = useMemo(() => {
        return Object.values(commandCenterLoader).some((value) => value);
    }, [commandCenterLoader]);

    const undeploying = useMemo(() => commandCenterLoader.undeploy, [commandCenterLoader.undeploy]);

    const setLoading = (loader_for: LoaderTypeFor, state: boolean) => {
        setCommandCenterLoader((prev: LoaderTypes) => ({
            ...prev,
            [loader_for]: state,
        }) as LoaderTypes);
    };

    return {
        loading,
        undeploying,
        setLoading,
    };
}

export default useLoader